module.exports = __webpack_public_path__ + "media/images/coming_soon-0ea77acd.png";